import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterBodyLogoBlockConfig } from '@front-platform/content-builder';
import { bigFooterBodyLogoBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface BigFooterBodyLogoBlockRuntimeConfig {}

export type BigFooterBodyLogoBlockConfigInput = Partial<
  Omit<BigFooterBodyLogoBlockConfig, keyof BigFooterBodyLogoBlockRuntimeConfig> &
    BigFooterBodyLogoBlockRuntimeConfig
>;
export type BigFooterBodyLogoBlockResolvedConfig = Omit<
  BigFooterBodyLogoBlockConfig,
  keyof BigFooterBodyLogoBlockRuntimeConfig
> &
  Partial<BigFooterBodyLogoBlockRuntimeConfig>;
export interface BigFooterBodyLogoBlockContract extends ConfigComponentContract<
  BigFooterBodyLogoBlockConfigInput,
  BigFooterBodyLogoBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-body-logo-block',
  templateUrl: './big-footer-body-logo-block.component.html',
  standalone: false,
})
export class BigFooterBodyLogoBlockComponent implements BigFooterBodyLogoBlockContract {
  readonly config = input<BigFooterBodyLogoBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterBodyLogoBlockConfig,
    BigFooterBodyLogoBlockRuntimeConfig
  >(bigFooterBodyLogoBlockResolveConfig, () => ({ config: this.config() }));
  get logo(): IContentBuilderFieldImage {
    return this.resolvedConfig()['logo'] as unknown as IContentBuilderFieldImage;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterBodyLogoBlockComponent, {
  'keyAliases': {},
});
